import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { ErrorBoundary } from './components/ErrorBoundary'
import './index.css'
import App from './App.tsx'

// After a deploy, tabs loaded before it still reference old hashed chunks;
// the server answers with the SPA fallback HTML and the dynamic import fails
// ("Failed to fetch dynamically imported module"). Reload once to pick up
// the new build — the timestamp guard prevents a reload loop if it persists.
window.addEventListener('vite:preloadError', (event) => {
  const key = 'chunk-reload-at'
  const last = Number(sessionStorage.getItem(key) || 0)
  if (Date.now() - last > 30_000) {
    sessionStorage.setItem(key, String(Date.now()))
    event.preventDefault()
    window.location.reload()
  }
})

createRoot(document.getElementById('root')!).render(
  // <StrictMode> Temporarily disabled to reduce re-renders during development
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  // </StrictMode>
  ,
)
